"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatPercentage = void 0;
/**
 * Returns the percentage number formatted
 * @param {number}            value      - value to format
 *
 * @return percentage number formatted for the provided value
 */
var formatPercentage = function (value) { return Math.round(value); };
exports.formatPercentage = formatPercentage;
